import { render, staticRenderFns } from "./ActionPersonSubstitued.vue?vue&type=template&id=0eefde96"
import script from "./ActionPersonSubstitued.vue?vue&type=script&lang=js"
export * from "./ActionPersonSubstitued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports